var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1601_3562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.75 3.43938C0.75 3.86104 0.91161 4.27856 1.2256 4.66812C1.53959 5.05768 1.99982 5.41165 2.58 5.7098C3.16018 6.00796 3.84896 6.24447 4.60701 6.40583C5.36505 6.56719 6.17752 6.65024 6.99802 6.65024C7.81852 6.65024 8.63099 6.56719 9.38903 6.40583C10.1471 6.24447 10.8359 6.00796 11.416 5.7098C11.9962 5.41165 12.4564 5.05768 12.7704 4.66812C13.0844 4.27856 13.246 3.86104 13.246 3.43938C13.246 2.5878 12.5878 1.77111 11.416 1.16896C10.2443 0.566802 8.6551 0.228516 6.99802 0.228516C5.34094 0.228516 3.75173 0.566802 2.58 1.16896C1.40827 1.77111 0.75 2.5878 0.75 3.43938Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99802 7.61644C4.44591 7.61644 2.25127 6.83007 1.2813 5.70312C0.939791 6.09991 0.75 6.53889 0.75 7.00068C0.75 8.77399 3.54734 10.2115 6.99802 10.2115C10.4487 10.2115 13.246 8.77399 13.246 7.00068C13.246 6.53889 13.0563 6.09991 12.7147 5.70312C11.7448 6.83007 9.55013 7.61644 6.99802 7.61644Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.99802 11.2652C4.4126 11.2652 2.19401 10.4582 1.24391 9.30762C0.925929 9.69268 0.75 10.1162 0.75 10.5609C0.75 12.3342 3.54734 13.7718 6.99802 13.7718C10.4487 13.7718 13.246 12.3342 13.246 10.5609C13.246 10.1162 13.0701 9.69268 12.7521 9.30762C11.802 10.4582 9.58344 11.2652 6.99802 11.2652Z",
    fill: "#00C087"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1601_3562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXp);
export default __webpack_public_path__ + "static/media/xp.5f6d7cc0ce1030d0bde67373ad74ec31.svg";
export { ForwardRef as ReactComponent };